import { render } from "./Pps.vue?vue&type=template&id=63f818b9&scoped=true"
import script from "./Pps.vue?vue&type=script&lang=js"
export * from "./Pps.vue?vue&type=script&lang=js"

import "./Pps.vue?vue&type=style&index=0&id=63f818b9&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63f818b9"]])

export default __exports__